import { useCart } from "react-use-cart";
import { Link } from "gatsby";
import { CartProps } from "./types";
import SVGS from "../../atoms/svgs";
import "./styles.scss";

const Cart = ({ classWrapper }: CartProps) => {
  const CartIcon = SVGS["cart"];
  const cartWrapperClassName = classWrapper ? `Cart ${classWrapper}` : "Cart";
  const { totalItems, isEmpty } = useCart();

  const isEmptyClassName = isEmpty ? " Cart--empty" : "";

  return (
    <div className={cartWrapperClassName + isEmptyClassName}>
      <Link
        className="Cart__link"
        to="/travel-supplies/shopping-cart">
        <CartIcon className="Cart__icon" />
        {!isEmpty && <div className="Cart__counter">{totalItems}</div>}
      </Link>
    </div>
  );
};

export default Cart;
